<template>
  <div>
    <v-app-bar app fixed dark>
      <v-app-bar-nav-icon @click.stop="$emit('toggleDrawer')" />

      <v-toolbar-title>{{ title }}</v-toolbar-title>

      <v-spacer />

      <BoltButton />

      <!-- <MobileDotsMenu /> -->
      <OLoadingLine
        :value="isLoading"
        absolute
        style="bottom: 0px"
        color="blue"
      />
    </v-app-bar>
  </div>
</template>

<script>
import BoltButton from '../../components/bolt/BoltButton.vue'

export default {
  components: { BoltButton },
  props: {
    title: {},
    isLoading: { type: Boolean, default: false }
  }
}
</script>

<style></style>
